"use client";
import React from "react";
import { useSelector } from "react-redux";
import { Box, Icon } from "@quintoandar-tokko/jopijs";
import style from "../fichaInfo.module.scss";
import CalendarButton from "@/components/calendar/calendarButton/CalendarButton";
import Skeletons from "../skelenton/Skeleton";
import Trans from "@/components/shared/Trans";
import translations from '../FichaInfo.trans.json';

export default function BookAVisitButton() {
  const { isBookingActive, loading, bookingUrl, is_from_network, for_colleague } = useSelector(
    (ste) => ste.FichaInfoSlice
  );

  if (!isBookingActive || is_from_network || for_colleague) return null;

  if (loading) return (
    <Box __css={{ marginTop: '8px !important', width: '100%' }}>
      <Skeletons width='100%' height={32} borderRadius={8} />
    </Box>
  )

  return (
    <CalendarButton
      className={style.bookAVisitButton}
      href={bookingUrl}
      icon={<Icon icon="icon-calendario" fontSize="20px" color="var(--colors-neutral-white)" />}
    >
      {Trans(translations, 'BookAVisit')}
    </CalendarButton>
  );
}
